import { Injectable } from '@angular/core';
import { BaseApiService } from './common/base-api.service';
import { API } from '../constants/api';

@Injectable({
  providedIn: 'root',
})
export class Menu {
  constructor(private baseApiService: BaseApiService) {}

  searchMenu() {
    return this.baseApiService.get(API.menu.search);
  }
}
